import {SET} from '../..';
import {WebshopCore, Webshop} from '@/services';
import {
    WebshopProduct,
    CampaignWebshopProduct,
    WebshopProductDetail
} from '@/services/models';

export default {
    namespaced: true,
    state: {
        sugestedProducts:[],
        coPurchases:[],
        paymentMethods: []
    },
    getters: {
        get(state) {
            return key => state[key];
        },
        getSugestedProducts: state => state.sugestedProducts
    },
    actions: {
        set({commit}, payload) {
            commit('SET', payload);
        },
        async getProductSuggestions({commit, rootState}, query){
            let response = await WebshopCore.GetProductSuggestions(query)
            let productIds = response.data.map(sp => sp.coPurchasedItem);
            let products = []
            if(productIds.length){
                let res = await Webshop.GetProductsByIds({chainId: query.chainId , productIds: productIds})
                products = res.data.ProductList.map(x => new WebshopProduct(x));
                var activeSites = rootState.webshop.settings?.activatedSalons.map(s => s.siteId) || []
                var deliverySites = rootState.webshop.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []

                products.forEach((p) => {
                    if (p.productDetails) {
                      let campaign = p.productDetails.campaigns.length && p.discounts.length ? p.productDetails.campaigns.find((c) => c.CampaignId == p.discounts[0].CampaignId) : p.productDetails.campaigns[0];
                        
                      p.bestCampaign = campaign;
                      p.salePrice = (campaign?.PromotionType === 4 || campaign?.PromotionType == 1 )  ? p.productDetails?.price : p.discounts?.length? p.discounts[0]?.DiscountPrice : p.productDetails.price;
                      var onlineStocks = p.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                      var shipmentStock = p.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                      p.onlineStock = onlineStocks.length ? onlineStocks.reduce((a,b)=>a+b) : 0
                      p.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a,b)=>a+b) : 0
                    }
                });
            }

            if (!products.length) return commit('SET', {key: 'sugestedProducts', value: []});
            commit('SET', {key: 'sugestedProducts', value: products});
            return products
        },
        async getCoPurchases({commit, rootState, rootGetters}, query){
            let response = await WebshopCore.GetCoPurchases(query)
            let productIds = response.data.map(sp => sp.coPurchasedItem);
            let products = []
            if(productIds.length){
                let res = await Webshop.GetProductsByIds({chainId: query.chainId , productIds: productIds})
                products = res.data.ProductList.map(x => new WebshopProduct(x));
                var activeSites = rootState.webshop.settings?.activatedSalons.map(s => s.siteId) || []
                var deliverySites = rootState.webshop.settings?.activatedSalons.filter(s => s.homeShipmentEnabled).map(s => s.siteId) || []
                 products.forEach((p) => {
                    if (p.productDetails) {
                        let campaign = p.productDetails.campaigns.length && p.discounts.length ? p.productDetails.campaigns.find((c) => c.CampaignId == p.discounts[0].CampaignId) : p.productDetails.campaigns[0];
                        p.bestCampaign = campaign;
                        p.salePrice = (campaign?.PromotionType === 4 || campaign?.PromotionType == 1 ) ? p.productDetails?.price : p.discounts?.length? p.discounts[0]?.DiscountPrice : p.productDetails.price;
                        var onlineStocks = p.productDetails.inventory.filter(x => activeSites.includes(x.siteId))?.map(x => x.stockAmount)
                        var shipmentStock = p.productDetails.inventory.filter(x => deliverySites.includes(x.siteId))?.map(x => x.stockAmount)
                        p.onlineStock = onlineStocks.length ? onlineStocks.reduce((a,b)=>a+b) : 0
                        p.stockForDelivery = shipmentStock.length ? shipmentStock.reduce((a,b)=>a+b) : 0
                    }
                });
            }
            
            if (!products.length) return commit('SET', {key: 'coPurchases', value: []});
            commit('SET', {key: 'coPurchases', value: products});

            return products
        },
        async getPaymentMethods({commit}){
            let response = await Webshop.GetPaymentMethodsConfig();
            if(response.data.responseCode === 200 && response.data.dto.length){
                commit('SET', {key: 'paymentMethods', value: response.data.dto});
            }
        }
       
    },

    mutations: {
        SET
    }
};
